import React from 'react';

import { clsx } from 'clsx';

import InfiniteBanner from 'src/components/elements/InfiniteBanner';

import { AboutTextFirstLines, AboutTextSecondLines } from './../../constants';

import styles from './About.scss';

const About = () => (
  <div className={styles.aboutContainer}>
    <p className={clsx(styles.title, styles.titleThin, styles.aboutTitle)}>We</p>
    <InfiniteBanner
      data={AboutTextFirstLines}
      textClassName={clsx(styles.title, styles.aboutTitle)}
    />
    <InfiniteBanner
      data={AboutTextSecondLines}
      textClassName={clsx(styles.title, styles.titleThin, styles.aboutTitle)}
      delay={0.25}
    />
  </div>
);

export default About;
